/* Company Confidential, Copyright (c) 2021 Signant Health, Ltd. All Rights Reserved. */

import React, { useState } from 'react';
import { Button } from '@material-ui/core';
import { useIntl } from 'react-intl';

export default function FooterButtons({ cancel, previous, next, close }) {
  const { formatMessage } = useIntl();
  const [nextDisabled, setNextDisabled] = useState(false);

  return (
    <div className="footer">
      {!!cancel && (
        <Button variant="outlined" color="primary" onClick={cancel}>
          {formatMessage({ id: 'general.cancel' })}
        </Button>
      )}
      {!!previous && (
        <Button variant="outlined" color="primary" onClick={previous}>
          {formatMessage({ id: 'general.previous' })}
        </Button>
      )}
      {!!next && (
        <Button
          aria-label="next"
          variant="contained"
          onClick={async () => {
            setNextDisabled(true);
            await next();
            setNextDisabled(false);
          }}
          disabled={nextDisabled}
          color="primary"
        >
          {formatMessage({ id: 'general.next' })}
        </Button>
      )}
      {!!close && (
        <Button variant="contained" onClick={close} color="primary">
          {formatMessage({ id: 'general.close' })}
        </Button>
      )}
    </div>
  );
}
